declare global {
  interface Window {
    $image_url?: (image: string) => string;
  }
}

/**
 * intelligently changes url to load from cdn if available.
 * @param   {String}  pathname  a path in /public
 */
function cdn(pathname: string) {
  if (window && window.$asset_host) {
    if (window.$rails_env === 'development') {
      // maintains consistency with rails img tag helpers
      return `//cfassets0.${window.$asset_host}${pathname}`;
    }
    return `//a.${window.$asset_host}${pathname}`;
  }

  // fallback to non-cdn path
  return pathname;
}

/**
 * replacement for @$image_url helper
 */
export default function $image_url(image: string): string {
  // regex for backwards compatibility
  if (image.match(/^((https?:)?\/\/|\/)/)) {
    return image;
  }

  return cdn('/images/' + image);
}

export const imageUrl = $image_url;

// TODO:  Was originally in a_c/utils/index. global $image_url is stil used in jade templates and `app/assets/javascripts/core_post_webpack/widgets/deprecated_confirm.js`
if (window) {
  window.$image_url = $image_url;
}
